/**
 * Colour lookups for the drum leaderboard.
 *
 * The piano leaderboard keeps equivalent tables as module-private constants;
 * these are the drum feature's own copy so neither page has to import from the
 * other. Values match so a grade or a podium place reads the same across the app.
 */

/** Grade chip colour. Falls back to `NEUTRAL` for anything unrecognised. */
export const GRADE_COLORS: Record<string, string> = {
  S: '#ffd700',
  'A+': '#81b29a',
  A: '#81b29a',
  B: '#f5a623',
  C: '#e07a5f',
  D: '#e07a5f',
  F: '#d4a574',
};

/** Podium colours for the top three; everyone else uses `NEUTRAL`. */
export const RANK_COLORS: Record<number, string> = {
  1: '#ffd700', // gold
  2: '#c0c0c0', // silver
  3: '#cd7f32', // bronze
};

/** Used wherever a grade or rank has no specific colour. */
export const NEUTRAL = '#78716c';

/** Bar colour for an accuracy percentage — green when strong, red when weak. */
export function accuracyColor(accuracy: number): string {
  if (accuracy >= 90) return '#81b29a';
  if (accuracy >= 70) return '#f5a623';
  return '#e07a5f';
}

/** Relative day label for a timestamp, e.g. "Today", "3d ago". */
export function formatDateShort(dateStr: string): string {
  const date = new Date(dateStr);
  const diffDays = Math.floor(
    (Date.now() - date.getTime()) / (1000 * 60 * 60 * 24),
  );

  if (diffDays <= 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays}d ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
